import { takeEvery, call, put } from 'redux-saga/effects';
import { getQcsSyncResources, qcsSyncCreateResource, qcsSyncUpdateResource, qcsSyncDeleteResource }
  from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';
import { transformResponseToFreeToSpend } from 'data/freeToSpend/freeToSpendTransformers';
import { Config, ENVIRONMENT } from 'utils/webappConfig';
import AxiosFactory from 'utils/axiosFactory';
import { getLogger } from 'utils/logger';
import * as transactionsActions from 'data/transactions/actions';
import { getFeatureFlags } from 'utils/featureFlags/selectors';
import store from 'store';

import * as actions from './freeToSpendActions';
import { getLastSyncDate } from './freeToSpendSelectors';

const log = getLogger('data/freeToSpend/freeToSpendSagas.js');

const mkResourceConfig = (props) => mkQcsSyncResourceConfig({
  resourceName: 'free to spend',
  resourceBaseUrl: '/free-to-spend',
  getLastSyncDate,
  transformResponseToResources: transformResponseToFreeToSpend,
  ...props,
});

export function* getFreeToSpendActionWatcher() {
  yield takeEvery(actions.getFreeToSpend, triggerFreeToSpendCalcAndGet);
}
function* triggerFreeToSpendCalcAndGet(action) {
  const requestUrl = `${Config.environments[ENVIRONMENT].services_url}/free-to-spend/calc`;
  try {
    const qcsAxios = AxiosFactory.get('qcs');
    yield call(qcsAxios.get, requestUrl);
  } catch (error) {
    log.error('free to spend calc failed with error ', error);
  } finally {
    const config = mkResourceConfig({
      successAction: actions.getFreeToSpendSuccess,
      failureAction: actions.getFreeToSpendFailure,
    });
    yield call(getQcsSyncResources, config, action);
  }
}

export function* createFreeToSpendActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.createFreeToSpendSuccess,
    failureAction: actions.createFreeToSpendFailure,
  });
  yield takeEvery(actions.createFreeToSpend, qcsSyncCreateResource, config);
}

export function* updateFreeToSpendActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.updateFreeToSpendSuccess,
    failureAction: actions.updateFreeToSpendFailure,
  });
  yield takeEvery(actions.updateFreeToSpend, qcsSyncUpdateResource, config);
}

export function* deleteFreeToSpendActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.deleteFreeToSpendSuccess,
    failureAction: actions.deleteFreeToSpendFailure,
  });
  yield takeEvery(actions.deleteFreeToSpend, qcsSyncDeleteResource, config);
}

export function* freeToSpendModifiedActionWatcher() {
  yield takeEvery(actions.createFreeToSpendSuccess, freeToSpendModified);
  yield takeEvery(actions.updateFreeToSpendSuccess, freeToSpendModified);
  yield takeEvery(actions.deleteFreeToSpendSuccess, freeToSpendModified);
}
function* freeToSpendModified() {
  yield put(actions.getFreeToSpend());
}

function* transactionModified(action) {
  const featureFlags = getFeatureFlags(store.getState());
  if (featureFlags?.get('spendingPlan')
    && action?.meta?.context && (
      action.meta.context === 'Reg_Income'
    || action.meta.context === 'Reg_BillsAndSubscriptions'
    || action.meta.context === 'Reg_Savings'
    || action.meta.context === 'Reg_Spendings'
    || action.meta.context === 'Reg_FTS'
    || action.meta.context === 'addAccounts'
    || action.meta.context === 'spending-plan'
    )
    && (action.type !== transactionsActions.getTransactionsSuccess.toString() || (action?.payload?.resources?.length > 0))
  ) {
    yield put(actions.getFreeToSpend());
  }
}

function* transactionModifiedActionWatcher() {
  yield takeEvery(transactionsActions.getTransactionsSuccess, transactionModified);
  yield takeEvery(transactionsActions.createTransactionsSuccess, transactionModified);
  yield takeEvery(transactionsActions.updateTransactionsSuccess, transactionModified);
  yield takeEvery(transactionsActions.deleteTransactionsSuccess, transactionModified);
  yield takeEvery(transactionsActions.performTransactionActionSuccess, transactionModified);
}

export default [
  getFreeToSpendActionWatcher,
  createFreeToSpendActionWatcher,
  updateFreeToSpendActionWatcher,
  deleteFreeToSpendActionWatcher,
  freeToSpendModifiedActionWatcher,
  transactionModifiedActionWatcher,
];
